/**
 * Lista as barragens ativas (A/B/C) da UPM — GUPM-134.
 * Alimenta o filtro de estrutura de Mapa (M2) e Instrumentação (M6).
 *
 * Segue o padrão do `useAvailableDams` (shift-handover), mas SEM recorte por
 * `barragem_ids` do perfil: o filtro sempre mostra as três estruturas.
 *
 * GUPM-167: a leitura de `dams` mudou de `supabase.from('dams')` direto para
 * o datasource `estrutura` (regra inviolável #2). Assinatura pública intacta.
 */
import { useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';
import type { DamOption } from '@/services/datasources';

// Re-export para consumidores que já importam o tipo daqui (ex.: StructureFilter).
export type { DamOption };

export function useDams() {
  const { estrutura } = useDataSources();
  return useQuery({
    queryKey: ['dams', 'active'],
    staleTime: 30 * 60 * 1000,
    queryFn: () => estrutura.listActiveDams(),
  });
}
